import * as types from './types';

const INITIAL_STATE = {
  startTime: null,
  endTime: null,
  groupId: null,
  defaultFunctionId: null,
  readOnly: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.DUTY_PLANNER_DATA_RECEIVED: {
      return {
        ...state,
        startTime: action.payload.startTime,
        endTime: action.payload.endTime,
        groupId: action.payload.groupId || state.groupId,
        defaultFunctionId: action.payload.defaultFunctionId || state.defaultFunctionId,
        readOnly: action.payload.readOnly || state.readOnly
      };
    }
    default: {
      return state;
    }
  }
};
